import { render, staticRenderFns } from "./UserControls.vue?vue&type=template&id=2e6549fa&scoped=true&"
import script from "./UserControls.vue?vue&type=script&lang=js&"
export * from "./UserControls.vue?vue&type=script&lang=js&"
import style0 from "./UserControls.vue?vue&type=style&index=0&id=2e6549fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6549fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
